/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

import {isPresent} from '../utils/lang';

/**
 * Pipe that sort keys by natural orders
 */
@Pipe({name: 'sort'})
export class SortPipe implements PipeTransform {
  public transform<T>(value: T[], path?: string, asc: boolean = true): T[] {
    if (!isPresent(value)) {
      return undefined;
    }

    if (!Array.isArray(value)) {
      throw new Error(`Invalid value for [SortPipe]: ${value}`);
    }
    return value.sort((a, b) => {
      if (this.getElementByPath(a, path) < this.getElementByPath(b, path)) {
        return asc ? -1 : 1;
      } else {
        return asc ? 1 : -1;
      }
    });
  }

  public getElementByPath(element: any, path: string): any {

    return path
      ? path.split('.').reduce((prev, current) => {

        return prev[current];
      }, element)
      : element;
  }
}
